import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "licencePaper"
const LicencePaperIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M11.25 16.5C11.664 16.5 12 16.836 12 17.25S11.664 18 11.25 18H8.25C7.836 18 7.5 17.664 7.5 17.25S7.836 16.5 8.25 16.5zM15.75 12.75C16.164 12.75 16.5 13.086 16.5 13.5S16.164 14.25 15.75 14.25H8.25C7.836 14.25 7.5 13.914 7.5 13.5S7.836 12.75 8.25 12.75zM15.75 9C16.164 9 16.5 9.336 16.5 9.75S16.164 10.5 15.75 10.5H8.25C7.836 10.5 7.5 10.164 7.5 9.75S7.836 9 8.25 9z" />
          <path
            fillRule="evenodd"
            d="M17.29 1.577C18.166 1.454 18.958 2.114 18.996 2.998L19.091 5.185Q19.09 5.238 19.089 5.29C19.754 5.443 20.25 6.04 20.25 6.75V21C20.25 21.83 19.578 22.5 18.75 22.5H5.25C4.422 22.5 3.75 21.83 3.75 21V5.25H3.756Q3.75 5.193 3.75 5.133C3.75 4.181 4.45 3.375 5.393 3.243zM5.25 21H18.75V6.75H5.25zM5.6 4.728C5.4 4.756 5.25 4.928 5.25 5.13 5.25 5.196 5.302 5.25 5.367 5.25H17.592L17.498 3.062z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default LicencePaperIcon
